module.exports = __webpack_public_path__ + "static/elle_mobile-794855af798183e89a3e42345cdfcdf5.png";